/**
 * Javascript behaviors for Filterrific.
 * http://filterrific.clearcove.ca
 *
 * Requires jQuery 1.7.0 or later.
 *
 * Released under the MIT license
 *
 */
// Create global Filterrific namespace
if (typeof Filterrific === 'undefined') {
  var Filterrific = {};
}

// Track active intervals so we can clean them up
Filterrific._activeIntervals = [];
Filterrific._initialized = false;

// Define function to submit Filterrific filter form
Filterrific.submitFilterForm = function(){
  var form = $(this).parents("form"),
      url = form.attr("action");
  // send before event
  $(form).trigger('loadingFilterrificResults');
  // turn on spinner
  $('.loading-table').show();
  $('.results-table').hide();
  // Submit ajax request
  $.ajax({
    url: url,
    data: form.serialize(),
    type: 'GET',
    dataType: 'script'
  }).done(function( msg ) {
    // send after event
    $(form).trigger('loadedFilterrificResults');
    $('.results-table').show();
    $('.loading-table').hide();
  });
};

// Clean up all active intervals and event handlers
Filterrific.teardown = function() {
  // Clear all polling intervals
  Filterrific._activeIntervals.forEach(function(ti) {
    clearInterval(ti);
  });
  Filterrific._activeIntervals = [];

  // Remove delegated change handlers to prevent stacking
  $('#filterrific_filter').off("change", ":input", Filterrific.submitFilterForm);

  // Remove observers from periodically-observed fields
  $(".filterrific-periodically-observed").off('keyup click mousemove');

  Filterrific._initialized = false;
};

//
// Embed jquery.observe_field.js to observe Filterrific filter inputs
//
// Copied from https://github.com/splendeo/jquery.observe_field
// Wrap in immediately invoked function for compatibility with other js libraries
//
(function($) {

  $.fn.filterrific_observe_field = function(frequency, callback) {
    frequency = frequency * 1000; // translate to milliseconds
    return this.each(function(){
      var $this = $(this);
      var prev = $this.val();
      var check = function() {
        if(removed()){ // if removed clear the interval and don't fire the callback
          if(ti) clearInterval(ti);
          return;
        }
        var val = $this.val();
        if(prev != val){
          prev = val;
          $this.map(callback); // invokes the callback on $this
        }
      };
      var removed = function() {
        return $this.closest('html').length == 0
      };
      var reset = function() {
        if(ti){
          clearInterval(ti);
          ti = setInterval(check, frequency);
        }
      };
      check();
      var ti = setInterval(check, frequency); // invoke check periodically
      // Store interval for cleanup
      Filterrific._activeIntervals.push(ti);
      // reset counter after user interaction
      $this.bind('keyup click mousemove', reset); //mousemove is for selects
    });
  };
})(jQuery);

Filterrific.init = function() {
  // Teardown any existing handlers/intervals first
  Filterrific.teardown();

  // Only init if there are filterrific elements on the page
  if ($('#filterrific_filter').length === 0 && $('.filterrific-periodically-observed').length === 0) {
    return;
  }

  console.log("Filterrific started");

  // Add change event handler to all Filterrific filter inputs.
  $('#filterrific_filter').on(
    "change",
    ":input",
    Filterrific.submitFilterForm
  );

  // Add periodic observer to selected inputs.
  // Use this for text fields you want to observe for change, e.g., a search input.
  $(".filterrific-periodically-observed").filterrific_observe_field(
    0.5,
    Filterrific.submitFilterForm
  );

  Filterrific._initialized = true;
};

window.initFilterrific = function(){
  Filterrific.init();
}

// Initialize event observers on turbo page loads
$(document).on('turbo:load', function() {
  initFilterrific();
});

// Clean up before navigating away (prevents zombie intervals)
$(document).on('turbo:before-visit', function() {
  Filterrific.teardown();
});
